import { lazy } from "react";
import { Pages } from "./types";

const publicRoute: Pages = [
  {
    path: "/articles-blogs",
    component: lazy(() => import("views/ArticlesPage/ArticlePageList")),
  },
  {
    path: "/articles-blogs/:article",
    component: lazy(() => import("views/ArticlesPage/ArticlePageDetails")),
  },
];

export default publicRoute;
